'use client';

import { BIO_MAX } from '@peach/types/tutors/identity-limits.js';
import { EditableText } from './EditableText';
import { taglineHeadline } from './intro-copy';

/** Between the name and the link: who this is, in the page's own words. */
const TAGLINE = 'block max-w-xl text-head-2 text-[var(--sf-ink)]';

/** The tagline as a visitor reads it in the masthead; nothing when there is none. */
export function Tagline({ tagline }: { tagline: string | null | undefined }) {
  const line = taglineHeadline(tagline);
  return line ? <p className={TAGLINE}>{line}</p> : null;
}

/** The owner's tagline, typed into where it stands in the masthead. */
export function TaglineEditor({
  tagline,
  onSave,
}: {
  tagline: string | null;
  /** Resolves to an error to show, or null once saved. An empty line clears it. */
  onSave: (next: string | null) => Promise<string | null>;
}) {
  return (
    <EditableText
      // A bio longer than the limit shows cut at a word, without the ellipsis a save would keep.
      value={taglineHeadline(tagline)?.replace(/…$/, '') ?? ''}
      placeholder="What you do, in one line"
      limit={BIO_MAX}
      label="Tagline"
      onSave={(next) => onSave(next || null)}
      className={TAGLINE}
    />
  );
}
